import PropTypes from 'prop-types';

export const isPasswordValid = (password, confirmPassword, setMessage) => {
    if (password.trim().length === 0) {
        setMessage('Escribe la nueva contraseña')
        return false;
    }
    else if (password.trim().length <= 7) {
        setMessage('La contraseña debe tener al menos 8 caracteres')
        return false;
    }
    else if (password !== confirmPassword) {
        setMessage('Las contraseñas no coinciden')
        return false;
    } else if (!(/[a-z]/.test(password))) {
        setMessage('La contraseña debe contener al menos una minúscula')
        return false;
    } else if (!(/[A-Z]/.test(password))) {
        setMessage('La contraseña debe contener al menos una mayúscula')
        return false;
    } else if (!(/[0-9]/.test(password))) {
        setMessage('La contraseña debe contener al menos un número')
        return false;
    } else if (/^$|\s+/.test(password)) {
        setMessage('La contraseña no debe llevar espacio en blanco')
        return false;
    }
    return true;
}

isPasswordValid.propTypes = {
    password: PropTypes.string.isRequired,
    confirmPassword: PropTypes.string.isRequired,
    setMessage: PropTypes.func.isRequired
}